import { type MetricResultRowsPage } from '@myre/app-agent-domain';
import { QueryResultApi } from '@myre/app-agent-generated/sdk/angular/QueryResultApi';

import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { ChatContextService } from './chat-context.service';

/** How many rows one fetch of the full-table view brings back. */
export const RESULT_PAGE_SIZE = 100;

/**
 * The result handle a registry answer left behind, read straight over HTTP.
 *
 * Neither call goes through a turn. A download and a page of a table are
 * GESTURES: the user has already asked their question, and routing the answer's
 * own affordances back through the model would spend a call to re-say what the
 * card already knows — and would fail as prose instead of as a status.
 */
@Injectable({ providedIn: 'root' })
export class ResultHandleService {
  private readonly _queryResultApi = inject(QueryResultApi);
  private readonly _chatContextService = inject(ChatContextService);

  /**
   * Ask the server to build the file and hand it to the browser.
   *
   * The response is streamed as a blob and saved under the name the server put
   * in `Content-Disposition` — the client names no file: the entry, the date and
   * the format are the server's to state.
   */
  public download(params: {
    handleId: string;
    format: 'xlsx' | 'csv';
  }): Promise<Blob> {
    const { handleId, format } = params;

    return firstValueFrom(
      this._queryResultApi.exportResult(
        { format, handleId, customerId: this._customerId() },
        { resolveBlob: true, download: true },
      ),
    );
  }

  public readRows(params: {
    handleId: string;
    offset: number;
    limit: number;
  }): Promise<MetricResultRowsPage> {
    const { handleId, offset, limit } = params;

    return firstValueFrom(
      this._queryResultApi.readRows({
        handleId,
        offset,
        limit,
        customerId: this._customerId(),
      }),
    );
  }

  private _customerId(): number {
    return this._chatContextService.context().params.customerId;
  }
}
